import ordersListActions from '../actionTypes/ordersListActions';

const initialState = {
  isLoading: true,
  data: {
    orders: [],
  },
  per: 20,
};

const OrdersListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ordersListActions.getOrdersList:
      return { ...state, isLoading: true };
    case ordersListActions.getOrdersListSuccess:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case ordersListActions.getOrdersListFailed:
      return {
        ...state,
        ...action.payload,
        data: {
          orders: [],
        },
        isLoading: false,
      };
    case ordersListActions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};

export default OrdersListReducer;
